﻿const Transition = {
    show: function (transitionElement, contentWrapper) {
        //transitionElement.classList.remove("hidden-custom");
        contentWrapper.get(0).classList.add("hidden-custom");
    },
    hide: function (transitionElement, contentWrapper) {
		//transitionElement.classList.add("hidden-custom");
		contentWrapper.get(0).classList.remove("hidden-custom");
    }
};

export default Transition;